// «مُختارات بَكْرِي» card stack. Each card gets a place in the stack
// (--o, 0 = front) and deck.css turns that into offset, tilt and size.
// The stack loops. Swipe the front card (it follows the finger), use the
// arrows, the dots or the arrow keys.
(function () {
  function setup(root) {
    if (root.__deck) return;
    root.__deck = true;

    var stage = root.querySelector('[data-deck-stage]');
    var cards = [].slice.call(root.querySelectorAll('[data-deck-card]'));
    var n = cards.length;
    if (!stage || n < 1) return;

    var sec = root.closest('section') || root.parentNode;
    var dots = sec ? [].slice.call(sec.querySelectorAll('[data-deck-dot]')) : [];
    var rtl = document.documentElement.dir === 'rtl';
    var index = 0;

    function offsetOf(i) {
      var off = ((i - index) % n + n) % n;
      if (off > n / 2) off -= n;
      return off;
    }

    function layout() {
      cards.forEach(function (card, i) {
        var off = offsetOf(i);
        var abs = Math.abs(off);
        card.style.setProperty('--o', off);
        card.style.zIndex = String(20 - abs * 2 - (off < 0 ? 1 : 0));
        if (off === 0) {
          card.setAttribute('data-front', '');
          card.removeAttribute('inert');
          card.setAttribute('aria-hidden', 'false');
        } else {
          card.removeAttribute('data-front');
          card.setAttribute('inert', '');
          card.setAttribute('aria-hidden', 'true');
        }
        if (abs > 2) { card.setAttribute('data-far', ''); } else { card.removeAttribute('data-far'); }
        card.style.removeProperty('--dx');
        card.style.removeProperty('--rot');
      });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    function go(step) {
      if (n < 2) return;
      index = ((index + step) % n + n) % n;
      layout();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-deck-prev]')) { go(-1); return; }
      if (e.target.closest('[data-deck-next]')) { go(1); }
    });

    if (sec) {
      sec.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-deck-dot]');
        if (!dot) return;
        index = parseInt(dot.getAttribute('data-deck-dot'), 10) || 0;
        layout();
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var forward = e.key === 'ArrowRight';
      if (rtl) forward = !forward;
      go(forward ? 1 : -1);
    });

    // Drag the front card. It follows the pointer and tilts; let go past
    // the threshold and it moves to the back of the stack.
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var active = null;
    var decided = false;
    var moved = false;

    stage.addEventListener('pointerdown', function (e) {
      var card = e.target.closest('[data-deck-card]');
      if (!card || !card.hasAttribute('data-front') || n < 2) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      active = card;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
      decided = false;
      moved = false;
    });

    stage.addEventListener('pointermove', function (e) {
      if (!active) return;
      var mx = e.clientX - startX;
      var my = e.clientY - startY;
      if (!decided) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        decided = true;
        if (Math.abs(my) > Math.abs(mx)) { active = null; return; }
        moved = true;
        root.classList.add('is-dragging');
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      dx = mx;
      active.style.setProperty('--dx', dx + 'px');
      active.style.setProperty('--rot', (dx / 18) + 'deg');
    });

    function release(commit) {
      if (!active) return;
      var card = active;
      active = null;
      root.classList.remove('is-dragging');
      if (commit && Math.abs(dx) > 60) {
        var forward = rtl ? dx > 0 : dx < 0;
        go(forward ? 1 : -1);
      } else {
        card.style.removeProperty('--dx');
        card.style.removeProperty('--rot');
      }
    }

    stage.addEventListener('pointerup', function () { release(true); });
    stage.addEventListener('pointercancel', function () { release(false); });

    // A drag must not also open the product.
    stage.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    layout();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-deck]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
